var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 11C3.69547 7.01759 7.01269 4 11 4C14.9873 4 18.3045 7.01759 19 11C18.3045 14.9824 14.9873 18 11 18C7.01269 18 3.69547 14.9824 3 11ZM11 14.8889C13.042 14.8889 14.6973 13.1478 14.6973 11C14.6973 8.85223 13.042 7.11111 11 7.11111C8.95802 7.11111 7.30267 8.85223 7.30267 11C7.30267 13.1478 8.95802 14.8889 11 14.8889ZM11 13.3333C9.7748 13.3333 8.7816 12.2887 8.7816 11C8.7816 9.7113 9.7748 8.66667 11 8.66667C12.2252 8.66667 13.2184 9.7113 13.2184 11C13.2184 12.2887 12.2252 13.3333 11 13.3333Z",
    fill: "#FFB829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeFill);
export default __webpack_public_path__ + "static/media/eye-fill.fd22be90fc3b7ff15ab690ed53e9d45f.svg";
export { ForwardRef as ReactComponent };